import styles from './Loader.module.scss'
import { Loader } from '@/components/Loader/Loader'
import cl from 'classnames'

export const LoaderWrapper = ({children, isLoading = false ,wrapperClassName}) => {
	return (
		<div className={styles.loadingWrapper}>
			{isLoading && (
				<div className={styles.loadingWrapper__container}>
					<div className={styles.loadingWrapper__loader}>
						<Loader />
					</div>

					<div className={cl(styles.loadingWrapper__wrapper, wrapperClassName)} />
				</div>
			)}

			{children}
		</div>
	)
}